import AdminDropdownCard from '@components/AdminDropdownCard/AdminDropdownCard.component'
import AdminPageHeader from '@components/AdminPageHeader/AdminPageHeader.component'
import ReusableModal from '@components/Modal/ReusableModal.component'
import { AddOutlined, CheckCircle } from '@mui/icons-material'
import { Box, Button, Divider, FormControlLabel, FormLabel, Radio, RadioGroup, styled, TextareaAutosize, TextField, Typography } from '@mui/material'
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { createFileRoute } from '@tanstack/react-router'
import axios from 'axios'
import { error } from 'console'
import { useEffect, useState } from 'react'
import { toast } from 'react-toastify'

export const Route = createFileRoute('/(admin)/_admin/create-category')({
    component: RouteComponent,
    validateSearch: (search: Record<string, unknown>) => {
    return {
        categoryId: search.categoryId as string | undefined,
    }
  },
});

const StyledTextArea = styled(TextareaAutosize)({
    backgroundColor: '#F9F9F9',
    width: '100%',
    minHeight: '135px',
    padding: '12px',
    borderRadius: '8px',
    border: '1px solid var(--Interviewer-Lightest-Black)',
    fontFamily: 'inherit',
    fontSize: '14px',
    lineHeight: '20px',
    resize: 'vertical',
    '&:focus': {
    outline: 'none',
    },
})

function RouteComponent() {
    const queryClient = useQueryClient();
    const { categoryId } = Route.useSearch()
    

    const [isEditPage, setIsEditPage] = useState(false)

    const [name, setName] = useState('');
    const [description, setDescription] = useState('');
    const [idOfCreatedCategory, setIdOfCreatedCategory] = useState('')
    const [isCreatedCategory, setIsCreatedCategory] = useState(false)

    console.log(idOfCreatedCategory);


    
    //Podaci za modal i pitanja
    const [openModal, setOpenModal] = useState(false)
    const [questionText, setQuestionText] = useState('');
    const [answers, setAnswers] = useState([
        { answer: '', correct: true },
        { answer: '', correct: false }
    ]);
    const [answerType, setAnswerType] = useState<number | null>(null);
    const [editingQuestionId, setEditingQuestionId] = useState<string | null>(null);


    //Ako je edit stranica setuj mi id kategorije
    useEffect(() => { 
        if (categoryId) {
            setIdOfCreatedCategory(categoryId)
        }
    }, [categoryId])


    // Kreiranje kategorije
    const handleSubmitCategory = () => {
        createCategoryMutation.mutate({name, description})
    }
    const createCategoryMutation = useMutation({
        mutationFn: async (categoryData: {name: string; description: string}) => {
            const token = localStorage.getItem('token');
            const response = await axios.post('https://interviewer.runasp.net/api/categories', categoryData, {
                headers: {
                    Authorization: `Bearer ${token}`,
                }
            });
            return response;
        },
        onSuccess: (data) => {
            toast.success('Successfully created category');
            setIdOfCreatedCategory(data.data);
            setIsCreatedCategory(true)
        },
        onError: (error) => {
            console.log(error);
        }
    })

    //Pribavljanje pitanja za kategoriju (samo ako postoji Id kategorije)
    const {data: categoryQuestions} = useQuery({
        queryKey: ['category-questions'],
        queryFn: async () => {
            const token = localStorage.getItem('token');
            const response = await axios.get(`https://interviewer.runasp.net/api/categories/${idOfCreatedCategory}/questions`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                }
            });
            console.log('pitanjaZaKategoriju', response);
            return response;
        },
        enabled: !!idOfCreatedCategory
    })

    // Kreiranje pitanja
    const handleQuestonSubmit = () => {
        if (isEditPage) {
            console.log('tip', answerType);
            const payload = {
                text: questionText,
                structure: answerType,
                suggestedAnswers: answers
            };
            questionEditMutation.mutate({ payload, editQuestionId: editingQuestionId });
        } else {
            const payload = {
                text: questionText,
                structure: answerType,
                ...(answerType !== 1 && { suggestedAnswers: answers }),
            };
            submitQuestionMutation.mutate(payload);
        }
    }
    const submitQuestionMutation = useMutation({
        mutationFn: async (body) => {
            console.log('kreiranjeeee');
            
            const token = localStorage.getItem("token");
            return axios.post(`https://interviewer.runasp.net/api/categories/${idOfCreatedCategory}/questions`,
                body,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );
        },
        onSuccess: (data) => {
            toast.success('Successfully created question!')
            setOpenModal(false)
            queryClient.invalidateQueries({ queryKey: ['category-questions'] });
            resetFormFileds();
        },
        onError: (error) => {
            console.log(error);
        }
    })
    // Zavrsetak kreiranja pitanja

    // Menjanje tipa pitanja
    const handleChangeAnswerType = (value:string) => {
        if (value === '3') {
            setAnswerType(3)
        } else if (value === '2') {
            setAnswerType(2)
            setAnswers(prev =>
                prev.map((a, i) => ({
                ...a,
                correct: i === 0
            }))
            )
        } else{
            setAnswerType (1)
            setAnswers([
                { answer: '', correct: true },
            ])
        }
    }

    useEffect(() => {
        console.log('pracenjepitanja', categoryQuestions);
    }, [categoryQuestions])

    //Reset forme
    const resetFormFileds = () => {
        setQuestionText('');
        setAnswerType(null)
        setAnswers([
            { answer: '', correct: true },
            { answer: '', correct: false }
        ])
    }

    // Pracenje tacnog odgovora
    const handleMarkCorrect = (answer, index) => {
        console.log('ovdeeee', answer);
        setAnswers(prev => {
            if (answerType === 3) {
                return prev.map((a, i) => 
                    i === index ? { ...a, correct: !a.correct } : a
                );
            }

            if (answerType === 2) {
                return prev.map((a, i) => ({
                    ...a,
                    correct: i === index
                }));
            }
            return prev;
        });
    }

    // Pracenje promene teksta
    const handleAnswerTextChange = (index, text) => {
        setAnswers(prev =>
            prev.map((a, i) =>
                i === index ? { ...a, answer: text } : a
            )
        );
    }

    // Editovanje pitanja
    const editQuestion = (question) => {
        setIsEditPage(true);
        setEditingQuestionId(question.id)
        setOpenModal(true);
        setAnswers(question.suggestedAnswers)
        setQuestionText(question.text)
        setAnswerType(question.structure)
    }
    const questionEditMutation = useMutation({
        mutationFn: async ({ payload, editQuestionId}) => {
            console.log('editovanjee');
            
            const token = localStorage.getItem('token');
            const results = await axios.put(`https://interviewer.runasp.net/api/questions/${editQuestionId}`, payload, {
                headers: {
                    Authorization: `Bearer ${token}`,
                }
            })
            return results;
        },
        onSuccess: (data) => {
            toast.success('Successfully updated question!');
            setOpenModal(false)
            queryClient.invalidateQueries({ queryKey: ['category-questions'] });
            resetFormFileds();
        },
        onError: (error) => {
            console.log(error);
        }
    })
    // Zavrsetak edita pitanja

    return <>
        <AdminPageHeader 
            title='Create Category'
        />
        <Box
            sx={{
                px: {
                    xs: '16px',
                    md: '32px'    
                },
                py: {
                    xs: '16px',
                    md: '32px'
                }
            }}
        >
        <Box 
            component='form'
            onSubmit={(e) => {
                e.preventDefault();
                if (isCreatedCategory) {
                    // Otvori modal za pitanja
                    setOpenModal(true);
                } else {
                    handleSubmitCategory();
                }
            }}
            sx={{display: 'flex', flexDirection: 'column', gap: {xs: '20px', md: '48px'}}}>
          <TextField
                label="Category Name"
                variant="outlined"
                fullWidth
                value={name}
                onChange={e => setName(e.target.value)}
                // required
          />
          <Box sx={{display: 'flex', flexDirection: 'column', gap: '8px'}}>
            <FormLabel sx={{fontSize: '16px', fontWeight: '500', color: 'var(--Interviewer-Black)'}}>Short Category Description</FormLabel> 
            <StyledTextArea 
              value={description}
              onChange={e => setDescription(e.target.value)}
            />
          </Box>
          <Box sx={{ display: 'flex', justifyContent: 'flex-end'}}>
            <Button 
                type='submit'
                variant="contained" 
                sx={{ minWidth: '120px' }}
            >
                {isCreatedCategory ? 'Add a question' : 'Create Category'}
            </Button>
          </Box>
        </Box>

        {isCreatedCategory && (
            <>
                <Divider sx={{mt: '16px', mb: '24px'}}/>
                <Box sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '24px'
                }}>
                    {categoryQuestions?.data?.length > 0 ? (
                        categoryQuestions?.data?.map((question, index:number) => (
                            <AdminDropdownCard
                                key={index}
                                questionId={question.id}
                                structure={question.structure}
                                questionText={question.text}
                                suggestedAnswers={question.suggestedAnswers}
                                index={index}
                                onEdit={(question) => editQuestion(question)}
                            />
                        ))
                        ) : (
                        <p>No questions found. Please make question</p>
                        )
                    }
                </Box>
            </>
        )}

        <ReusableModal open={openModal} onClose={() => setOpenModal(false)}>
            <Typography variant='h2' sx={{pb: '20px'}}>Add a question</Typography>
            <Box 
                component='form'
                onSubmit={(e) => {
                    e.preventDefault()
                    handleQuestonSubmit()
                }}
            >
                <FormLabel sx={{fontSize: '16px', fontWeight: '500', color: 'var(--Interviewer-Black)'}}>Question Text</FormLabel> 
                <StyledTextArea 
                    value={questionText}
                    onChange={e => setQuestionText(e.target.value)}
                    placeholder="Add a question text here"
                    required
                />

                <Box sx={{display: 'flex', flexDirection: {xs: 'column', md: 'row'} ,alignItems: {xs: 'start', md: 'center'}, justifyContent: 'space-between', py: '20px'}}>
                    <Typography sx={{ fontWeight: 500, color: 'var(--Interviewer-Black)' }}>Choose answer type</Typography>
                    <RadioGroup 
                        row
                        onChange={(e) => handleChangeAnswerType(e.target.value)}
                        value={answerType?.toString() || ''}
                    >
                        <FormControlLabel
                            value={3} 
                            control={<Radio required/>} 
                            label="Multiple Choice"
                        />
                        <FormControlLabel
                            value={2} 
                            control={<Radio required/>} 
                            label="One answer"
                        />
                        <FormControlLabel
                            value={1} 
                            control={<Radio required/>} 
                            label="Textual"
                        />
                    </RadioGroup>
                </Box>

                <Divider />

                <Box sx={{py: '20px'}}>
                    {answers.map((answer, index) => (
                        <Box key={index} sx={{mb: '24px'}}>
                            <Box sx={{display: 'flex', alignItems: 'center', justifyContent: 'space-between'}}>
                                <Typography>Answer {index +1}</Typography>
                                <Box sx={{display: 'flex', alignItems: 'center', gap: '5px'}}>
                                    <CheckCircle
                                        onClick={() => handleMarkCorrect(answer, index)} 
                                        fontSize="small" 
                                        sx={{ 
                                            color: answer.correct ? 'var(--Interviewer-Green)' : 'var(--Interviewer-Lightest-Black)',
                                            cursor: 'pointer',
                                            maxWidth: '16px',
                                            maxHeight: '16px'
                                        }}/>
                                    <Typography>Mark</Typography>
                                </Box>
                            </Box>

                            <Box sx={{pt: '12px'}}>
                                <TextField
                                    placeholder={`Add answer text here`}
                                    fullWidth
                                    multiline
                                    required
                                    sx={{padding: '0px'}}
                                    value={answer.answer}
                                    onChange={(e) => handleAnswerTextChange(index, e.target.value)}
                                />
                        </Box>
                        </Box>
                    ))}

                    {answerType !== 1 && (
                        <Box 
                            sx={{
                                p: '24px',
                                border: '1px dashed var(--Interviewer-Near-White)',
                                borderRadius: '12px',
                                display: 'flex',
                                alignItems: 'center',
                                gap: '30px', 
                                cursor: 'pointer'
                            }}
                            onClick={() => {
                                setAnswers(prev => [
                                    ...prev,
                                    {answer: '', correct: false}
                                ]);
                            }}
                        >
                            <Box sx={{background: '#fff', boxShadow: '0px 0.75px 1.5px 0px #0205111A', p: '10px', borderRadius: '10px'}}>
                                <AddOutlined color="primary" fontSize='small'/>
                            </Box>
                            <Typography>Add another choice</Typography>
                        </Box>
                    )}
                </Box>
                <Button variant='contained' type='submit' fullWidth>{isEditPage ? 'Update question' : 'Add a question'}</Button>
            </Box>
        </ReusableModal>
    </Box>
    </>
}
